var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6973 10.7343C11.0194 11.5867 10.1223 12.2386 9.102 12.62C8.08172 13.0014 6.97684 13.098 5.90584 12.8994C4.83484 12.7007 3.83812 12.2144 3.02259 11.4925C2.20706 10.7705 1.60348 9.84032 1.27658 8.80153C0.949684 7.76275 0.911798 6.65459 1.16699 5.59592C1.42218 4.53724 1.96082 3.56798 2.72514 2.79209C3.48947 2.0162 4.45064 1.46295 5.50557 1.19167C8.42999 0.441825 11.4572 1.94675 12.5747 4.75116M13 1.00196V4.75116H9.24979",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.bc15355dea7bcecfc80e72d5eb6075ee.svg";
export { ForwardRef as ReactComponent };